import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelopeCircleCheck,
  faEye,
  faThumbsUp,
  faThumbsDown,
} from "@fortawesome/free-solid-svg-icons";
import IconHome from "../../../styles/icons/IconHome";

const LeadHistory = (name: string, selectedLead: any) => {
  const leadHistoryData = selectedLead?.assignedUsers?.[0];
  const leadCreatedAt = selectedLead.createdAt;
  const LeadOwnerName =
    leadHistoryData?.firstName + " " + leadHistoryData?.lastName;

  const formatDate = (date?: string | Date) => {
    if (!date) return "";

    let parsedDate: Date;

    if (date instanceof Date) {
      parsedDate = date;
    } else if (date.includes("/")) {
      // DD/MM/YYYY
      const [day, month, year] = date.split("/");
      parsedDate = new Date(Number(year), Number(month) - 1, Number(day));
    } else {
      // ISO format / normal JS date string
      parsedDate = new Date(date);
    }

    if (isNaN(parsedDate.getTime())) return "";

    return parsedDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className="w-100 status-container">
      <div className="item active">
        <IconHome breadcrumb="deliveredIcon" />
        {"  "}
        <span>{formatDate(leadCreatedAt)}</span>
        <span className="mx-2">Lead Delivered to {LeadOwnerName}</span>
      </div>

      {leadHistoryData?.isViewed ? (
        <div className={leadHistoryData?.isViewed ? "item active" : "item"}>
          <IconHome breadcrumb="viewHistoryIcon" />{" "}
          <span>{formatDate(leadHistoryData?.viewedAt)}</span>
          <span className="mx-2">{LeadOwnerName} Viewed the Lead</span>
        </div>
      ) : null}
      {leadHistoryData?.isLiked ? (
        <div className={leadHistoryData?.isLiked ? "item active" : "item"}>
          <IconHome breadcrumb="likeIcon" />{" "}
          <span>{formatDate(leadHistoryData?.likedAt)}</span>
          <span className="mx-2">{LeadOwnerName} Like the Lead</span>
        </div>
      ) : leadHistoryData?.isDisliked ? (
        <div className={leadHistoryData?.isDisliked ? "item active" : "item"}>
          <IconHome breadcrumb="dislikeIcon" />{" "}
          <span>{formatDate(leadHistoryData?.dislikedAt)}</span>
          <span className="mx-2">{LeadOwnerName} Dislike the Lead</span>
        </div>
      ) : null}
    </div>
  );
};

export default LeadHistory;
